import { Box, Switch, Typography } from '@mui/material';

// The "Active" switch of a threshold form, with what it actually does spelled out - a switch labelled just "Active"
// left people guessing whether "off" meant "no warning", "use the default" or "delete it".
//   On  = this threshold is used when results are worked out.
//   Off = it is ignored (kept in the list; switch it back on any time). `offHint` says what happens instead.
const ActiveSwitch = ({ form, setForm, offHint }) => (
  <Box>
    <Box display="flex" alignItems="center" gap={1}>
      <Switch checked={!!form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} />
      {form.is_active ? 'Active - used in results' : 'Off - ignored in results'}
    </Box>
    {!form.is_active && offHint && (
      <Typography variant="caption" color="text.secondary" component="div">{offHint}</Typography>
    )}
  </Box>
);

export default ActiveSwitch;
